// Декларация для глобальной функции TargetAds
declare global {
    interface Window {
        targetAdsDataLayer: any;
        utmTracking?: {
            safeGetItem: (key: string) => string | null;
            safeSetItem: (key: string, value: string) => boolean;
            isLocalStorageAvailable: () => boolean;
        };
    }
    function _targetadsTag(action: string, params?: any): void;
}

document.addEventListener('DOMContentLoaded', () => {
    // Код для кастомного списка
    initCustomSelects();
    // Маска для телефона
    initPhoneMask();

    // Функция для получения Yandex Metrica Client ID (дублируем из utm.ts для надежности)
    function getYmClientIdForForm(): string | undefined {
        let clientId: string | undefined;
        
        // Пытаемся получить через объект счетчика
        const counter = (window as any)['yaCounter97951132'];
        if (counter && typeof counter.getClientID === 'function') {
            try {
                clientId = counter.getClientID();
                if (clientId) return clientId;
            } catch (e) {
                // Игнорируем ошибки
            }
        }
        
        // Пытаемся получить через функцию ym
        const ym = (window as any).ym;
        if (typeof ym === 'function') {
            try {
                ym(97951132, 'getClientID', function(id: string) {
                    clientId = id;
                });
                if (clientId) return clientId;
            } catch (e) {
                // Игнорируем ошибки
            }
        }
        
        // Пытаемся получить из cookies
        function getCookieForForm(name: string): string | undefined {
            const match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
            return match ? decodeURIComponent(match[2]) : undefined;
        }
        
        const ymCookie = getCookieForForm('_ym_uid') || getCookieForForm('_ym_97951132_uid');
        if (ymCookie) {
            return ymCookie;
        }
        
        return undefined;
    }

    // Функция для сохранения ymClientId в localStorage
    function saveYmClientIdToStorage(ymClientId: string): void {
        try {
            // Используем безопасную функцию из utm.ts если доступна
            if (window.utmTracking && window.utmTracking.safeGetItem && window.utmTracking.safeSetItem) {
                const existingParams = window.utmTracking.safeGetItem('marketing_params');
                let params: Record<string, string> = {};
                
                if (existingParams) {
                    try {
                        params = JSON.parse(existingParams);
                    } catch (e) {
                        params = {};
                    }
                }
                
                params.ym_client_id = ymClientId;
                window.utmTracking.safeSetItem('marketing_params', JSON.stringify(params));
            } else {
                // Fallback к обычному localStorage
                const existingParams = localStorage.getItem('marketing_params');
                let params: Record<string, string> = {};
                
                if (existingParams) {
                    try {
                        params = JSON.parse(existingParams);
                    } catch (e) {
                        params = {};
                    }
                }
                
                params.ym_client_id = ymClientId;
                localStorage.setItem('marketing_params', JSON.stringify(params));
            }
        } catch (e) {
            // console.warn('Failed to save ymClientId to storage:', e);
        }
    }

    // Безопасное получение параметров из localStorage с fallback
    function getMarketingParams(): Record<string, string> {
        try {
            // Используем безопасную функцию из utm.ts если доступна
            if (window.utmTracking && window.utmTracking.safeGetItem) {
                const raw = window.utmTracking.safeGetItem('marketing_params');
                if (!raw) return {};
                return JSON.parse(raw);
            }
            
            // Fallback к обычному localStorage
            const raw = localStorage.getItem('marketing_params');
            if (!raw) return {};
            return JSON.parse(raw);
        } catch (e) {
            // console.warn('Failed to get marketing params:', e);
            
            // iOS specific debugging
            // if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            //     console.log('[iOS] Marketing params retrieval failed');
            //     
            //     // Проверяем доступность localStorage
            //     const isAvailable = window.utmTracking ? 
            //         window.utmTracking.isLocalStorageAvailable() : 
            //         (() => {
            //             try {
            //                 const test = '__test__';
            //                 localStorage.setItem(test, test);
            //                 localStorage.removeItem(test);
            //                 return true;
            //             } catch {
            //                 return false;
            //             }
            //         })();
            //         
            //     console.log('[iOS] LocalStorage available:', isAvailable);
            // }
            
            return {};
        }
    }

    // Обработка отправки формы
    function initFormSubmit(context: HTMLElement | Document = document): void {
        const forms = context.querySelectorAll('form');
        forms.forEach(form => {
            // Чтобы не навешивать обработчик повторно
            if ((form as any)._hasSubmitHandler) return;
            (form as any)._hasSubmitHandler = true;

            form.addEventListener('submit', function(e) {
                e.preventDefault();

                // Базовая валидация
                const nameInput = form.querySelector('input[name="name"]') as HTMLInputElement;
                const phoneInput = form.querySelector('input[name="phone"]') as HTMLInputElement;
                const classInput = form.querySelector('input[name="class"]') as HTMLInputElement;

                if (!nameInput.value.trim()) {
                    nameInput.focus();
                    return;
                }

                if (!phoneInput.value.trim() || phoneInput.value.length < 17) { // +7 (XXX) XXX-XX-XX
                    phoneInput.focus();
                    return;
                }

                if (!classInput.value.trim()) {
                    // Если не выбран класс, показываем выпадающий список
                    const selectBtn = form.querySelector('[data-select-btn]') as HTMLButtonElement;
                    if (selectBtn) {
                        selectBtn.click();
                    }
                    return;
                }

                // Получаем параметры из localStorage
                const marketingParams = getMarketingParams();
                
                // Дополнительная попытка получить ymClientId если его нет в сохраненных параметрах
                if (!marketingParams.ym_client_id) {
                    const ymClientId = getYmClientIdForForm();
                    if (ymClientId) {
                        marketingParams.ym_client_id = ymClientId;
                        // Сохраняем в localStorage для будущих отправок
                        saveYmClientIdToStorage(ymClientId);
                    }
                }

                // Собираем данные формы
                const formData = new FormData(form);

                // Добавляем действие для WordPress admin-ajax
                formData.append('action', 'amoWebhook');

                // Получаем параметры для AJAX запроса из глобального объекта
                const params = (window as any).formWebhookParams || {};

                // Добавляем nonce для безопасности, если доступен
                if (params.nonce) {
                    formData.append('nonce', params.nonce);
                }

                // iOS specific debugging
                // if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
                //     console.log('[iOS] Form submit - marketing params:', marketingParams);
                // }
                
                // Добавляем все маркетинговые параметры к данным формы
                Object.keys(marketingParams).forEach(key => {
                    formData.append(key, marketingParams[key]);
                });

                // Получаем URL для AJAX из глобального объекта или используем стандартный
                const ajaxUrl = params.ajax_url || '/wp-admin/admin-ajax.php';

                // Отправка данных
                fetch(ajaxUrl, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        // iOS specific debugging
                        // if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
                        //     console.log('[iOS] Form submitted successfully');
                        // }
                        
                        try {
                            _targetadsTag('event', {"event_name":"freeform_sending"});
                            _targetadsTag('event', {'event_params': {'uid':'<user_id>'}});
                        } catch (e) {
                            // console.warn('TargetAds tracking failed:', e);
                        }
                        
                        // Помечаем все формы как отправленные
                        document.querySelectorAll('.callback__form form').forEach(formElement => {
                            formElement.closest('.callback__form')?.classList.add('sended');

                            // Меняем текст во всех кнопках
                            const submitBtn = formElement.querySelector('.callbackForm__submit');
                            if (submitBtn) {
                                submitBtn.textContent = 'Отправлено';
                                submitBtn.setAttribute('disabled', 'disabled');
                            }
                        });
                        // Показываем success-модалку, если есть
                        if (data.modal_html) {
                            const modal = document.querySelector('.modal');
                            const modalContent = modal?.querySelector('.modal__content');
                            if (modal && modalContent) {
                                // Сохраняем оригинальное содержимое, если еще не сохранено
                                if (!(modal as any)._originalContent) {
                                    (modal as any)._originalContent = modalContent.innerHTML;
                                }
                                modalContent.innerHTML = data.modal_html;
                                modal.classList.add('open');
                                modal.classList.add('success-wrapper');

                                // Функция для закрытия модалки и возврата оригинального содержимого
                                const closeModal = () => {
                                    modal.classList.remove('open');
                                    modal.classList.remove('success-wrapper');
                                    if ((modal as any)._originalContent) {
                                        modalContent.innerHTML = (modal as any)._originalContent;
                                    }
                                };

                                // Навешиваем обработчики на крестик и ссылку
                                const closeBtn = modalContent.querySelector('.success__modal__close');
                                if (closeBtn) {
                                    closeBtn.addEventListener('click', closeModal);
                                }
                                const tgLink = modalContent.querySelector('.success__modal__link');
                                if (tgLink) {
                                    tgLink.addEventListener('click', closeModal);
                                }
                            }
                        }
                    } else {
                        // console.error('Ошибка отправки формы:', data.message);
                        
                        // iOS specific debugging
                        // if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
                        //     console.log('[iOS] Form submission failed:', data);
                        // }
                    }
                })
                .catch(error => {
                    // console.error('Ошибка отправки формы:', error);
                    
                    // iOS specific debugging
                    // if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
                    //     console.log('[iOS] Form submission error:', error);
                    // }
                });
            });
        });
    }
    
    // Инициализация отправки формы для всего документа
    initFormSubmit();
    
    // Экспортируем функцию для использования в других модулях (делаем это сразу после объявления)
    (window as any).initFormSubmit = initFormSubmit;
});

// ВЫНОСИМ ФУНКЦИИ ДЛЯ ПОВТОРНОГО ИСПОЛЬЗОВАНИЯ
export function initCustomSelects(context: HTMLElement | Document = document): void {
    context.querySelectorAll('[data-select]').forEach(select => {
        const btn = select.querySelector('[data-select-btn]') as HTMLButtonElement | null;
        const dropdown = select.querySelector('[data-select-dropdown]') as HTMLUListElement | null;
        const label = select.querySelector('[data-select-label]') as HTMLElement | null;
        const input = select.querySelector('[data-select-input]') as HTMLInputElement | null;

        if (!btn || !dropdown || !label || !input) return;

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const isActive = dropdown.classList.toggle('active');
            btn.classList.toggle('rotated', isActive);
        });

        dropdown.querySelectorAll('li').forEach(item => {
            item.addEventListener('click', () => {
                label.textContent = item.textContent;
                input.value = item.getAttribute('data-value') || '';
                dropdown.classList.remove('active');
                btn.classList.remove('rotated');
            });
        });

        document.addEventListener('click', (e) => {
            if (!(e.target instanceof Node) || !select.contains(e.target)) {
                dropdown.classList.remove('active');
                btn.classList.remove('rotated');
            }
        });
    });
}

export function initPhoneMask(context: HTMLElement | Document = document): void {
    const phoneInputs = context.querySelectorAll('input[type="tel"]');
    phoneInputs.forEach(input => {
        const phoneInput = input as HTMLInputElement;
        phoneInput.addEventListener('input', onPhoneInput);
        phoneInput.addEventListener('keypress', onPhoneKeyPress);
        phoneInput.addEventListener('focus', onPhoneFocus);
        phoneInput.addEventListener('blur', onPhoneBlur);
    });
}

// Обработчик события input
function onPhoneInput(e: Event): void {
    const input = e.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Удаляем все нецифровые символы

    // Начинаем с кода страны '7'
    if (value.startsWith('7')) {
        value = value.substring(1);
    }
    if (value.startsWith('8')) {
        value = value.substring(1);
    }

    // Ограничиваем количество цифр до 10 (без кода страны)
    if (value.length > 10) {
        value = value.substring(0, 10);
    }

    let formattedValue = '+7 ';

    if (value.length > 0) {
        formattedValue += '(';
    }
    if (value.length >= 1) {
        formattedValue += value.substring(0, 3);
    }
    if (value.length >= 4) {
        formattedValue += ') ';
        formattedValue += value.substring(3, 6);
    }
    if (value.length >= 7) {
        formattedValue += '-';
        formattedValue += value.substring(6, 8);
    }
    if (value.length >= 9) {
        formattedValue += '-';
        formattedValue += value.substring(8, 10);
    }

    input.value = formattedValue;
}

// Разрешаем ввод только цифр
function onPhoneKeyPress(e: KeyboardEvent): void {
    const char = String.fromCharCode(e.which || e.keyCode);
    if (!/\d/.test(char)) {
        e.preventDefault();
    }
}

// При фокусе добавляем начало маски
function onPhoneFocus(e: Event): void {
    const input = e.target as HTMLInputElement;
    if (input.value === '') {
        input.value = '+7 (';
    }
}

// При потере фокуса очищаем, если только начало маски
function onPhoneBlur(e: Event): void {
    const input = e.target as HTMLInputElement;
    if (input.value === '+7 (' || input.value === '+7 ') {
        input.value = '';
    }
}
